import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner, Text } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DateFieldComponent from "../../../components/inputs/Datefield/DatefieldComponent";
import RadioGroupComponent from "../../../components/inputs/RadioGroup/RadioGroupComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { useAppDispatch } from "../../../hooks/hooks";
import { resetUserData, setUserData } from "../../../redux/slices/users/user";
import { RootState } from "../../../redux/store";
import { routes } from "../../../routes";
import {
  createUser,
  getUserNameSuggestion,
} from "../../../services/user/createUser";
import { updateUser } from "../../../services/user/updateUser";
import { UserType } from "../../../types/User";
import { Create_Edit_UserFormValidation } from "./Create_Edit_UserFormValidation";
import { useCallback,useState } from "react";
import { debounce, isEmpty } from "lodash";
import { resetPassword } from "../../../services/user/resetPassword";
import { setPdfPreviewType } from "../../../redux/slices/report/report";
import { useGetRolesQuery } from "../../../hooks/useGetRolesQuery";
import { addUserRole } from "../../../services/user/addUserRole";
import { removeUserRole } from "../../../services/user/removeUserRole";
import { stringToBoolean } from "../../../utils/utilities";
import { Countries, Country } from "../../../utils/codes";
import SelectSearchableComponent from "../../../components/inputs/Select/SelectSearchableComponent";
import MultiSelectComponent from "../../../components/inputs/Select/MultiSelectComponent";
import * as yup from "yup";
import { AlertDialog } from '@radix-ui/themes';

export const EditMyUser = () => {
  const defaultValues = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();
  const [showChangesNotification, setShowChangesNotification] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm<UserType>({
    resolver: yupResolver(Create_Edit_UserFormValidation),
    defaultValues,
    mode: "onBlur",
  });

  const { mutateAsync, isLoading } = useMutation(updateUser, {
    onSuccess: () => {
        setShowChangesNotification(true); 
     
    },
    
    onError: () => {
      toast.error("Erro ao atualizar o perfil.");
    },
  });
    
  const closeDialog= () => {
  setShowChangesNotification(false);
  navigate(routes.dashboard); }
 

  const onSubmit = handleSubmit(async (data) => {
    data.twoFactorEnabled = stringToBoolean(data.twoFactorEnabled);
    data.isForeign = stringToBoolean(data.isForeign);
    await mutateAsync(data);
  });

  const watchBank = watch("banKAcc"); 
  const watchIsForeign = watch("isForeign");
  const filteredCountries = Countries.filter(
  (country: Country) =>
    !stringToBoolean(watchIsForeign) || country.code !== "MOZ"
);

  return (
   <Card size="3">
  <form onSubmit={onSubmit} noValidate>
    <Flex direction="column" gap="6">
     
      <Flex direction="column" gap="4">
        <Text size="3" weight="bold">Identificação</Text>
        <Flex gap="4">
          <TextFieldComponent
            name="name"
            label="Nome"
            control={control}
            errors={errors}
            fieldProps={{ placeholder: "Nome completo" }}
            required
            style={{ width: "100%" }}
          />
          <TextFieldComponent
            name="userName"
            label="Utilizador"
            control={control}
            errors={errors}
            fieldProps={{ disabled: true }}
            required
            style={{ width: "100%" }}
          />
        </Flex>
        <Flex gap="4">
          <TextFieldComponent
            name="email"
            label="Email"
            control={control}
            errors={errors}
            fieldProps={{ type: "email" }}
            required
            style={{ width: "100%" }}
          />
          <TextFieldComponent
            name="secondaryEmail"
            label="Email Alternativo"
            control={control}
            errors={errors}
            fieldProps={{ type: "email" }}
            style={{ width: "100%" }}
          />
        </Flex>
        <Flex gap="4">
          <TextFieldComponent
            name="bi"
            label="BI"
            control={control}
            errors={errors}
            fieldProps={{ disabled: true }}
            required
            style={{ width: "100%" }}
          />
          <TextFieldComponent
            name="nuit"
            label="NUIT"
            control={control}
            errors={errors}
            fieldProps={{ disabled: true }}
            required
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>

  
      <Flex direction="column" gap="4">
        <Text size="3" weight="bold">Contactos</Text>
        <Flex gap="4">
          <TextFieldComponent
            name="phoneNumber"
            label="Telefone"
            control={control}
            errors={errors}
            required
            style={{ width: "100%" }}
          />
          <TextFieldComponent
            name="secondaryPhoneNumber"
            label="Telefone Alternativo"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>

      <Flex direction="column" gap="4">
        <Text size="3" weight="bold">Dados bancários</Text>
        <Flex gap="4">
          <TextFieldComponent
            name="nib"
            label="NIB"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
          />
          <SelectSearchableComponent
            name="banKAcc"
            label="Banco"
            control={control}
            errors={errors}
            options={[
              { value: "BCI", label: "BCI" },
              { value: "Millennium", label: "Millennium" },
            ]}
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>

      <Flex direction="column" gap="4">
        <Text size="3" weight="bold">Segurança</Text>
        <Flex gap="4">
          <RadioGroupComponent
            name="twoFactorEnabled"
            label="Autenticação 2 Fatores"
            control={control}
            errors={errors}
            options={[
              { value: "true", label: "Sim" },
              { value: "false", label: "Não" },
            ]}
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>

      
      <Flex direction="column" gap="4">
        <Text size="3" weight="bold">Nacionalidade</Text>
        <Flex gap="4">
          <RadioGroupComponent
            name="isForeign"
            label="Estrangeiro"
            control={control}
            errors={errors}
            options={[
              { value: "true", label: "Sim" },
              { value: "false", label: "Não" },
            ]}
            style={{ width: "100%" }}
          />
          <SelectSearchableComponent
            name="countryDescription"
            label="País"
            control={control}
            errors={errors}
            options={filteredCountries .map((c: Country) => ({
              label: c.label,
              value: c.code,
            }))}
            fieldProps={{ disabled: !stringToBoolean(watchIsForeign) }}
            style={{ width: "100%" }}
          />
        </Flex>
      </Flex>

      {/* Botões */}
      <Flex gap="4" justify="end">
        <Button type="submit" disabled={isLoading} variant="surface">
          {isLoading ? (
            <Spinner loading>
              <EnterIcon />
            </Spinner>
          ) : (
            <EnterIcon />
          )} {" "}
          Atualizar
        </Button>
      </Flex>
    </Flex>
  </form>
  {showChangesNotification && (
   <AlertDialog.Root open={showChangesNotification} onOpenChange={() => setShowChangesNotification(false)}>
      <AlertDialog.Content maxWidth="1000px">
        <AlertDialog.Title>Alterações guardadas</AlertDialog.Title>
        <AlertDialog.Description>
          As alterações feitas terão efeito após o próximo login do utilizador.
        </AlertDialog.Description>
        <Flex gap="3" justify="center" mt="4">
          <AlertDialog.Cancel>
            <Button type="button" variant="soft" color="gray">
              Entendido
            </Button>
          </AlertDialog.Cancel>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )}
</Card>
  );
}